import { defineComponent as _defineComponent } from 'vue'
import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import { du } from '@/ui/i18n/i18n';
  import type { CourseReportDetail } from '@/entities/trainings/course-report/model';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseReportInfo',
  props: {
    report: {
      type: Object as () => CourseReportDetail,
      required: true,
    },
  },
  setup(__props) {

  

return { __sfc: true,PageSubtitle, du }
}

})